import { PARTICLE_COUNTS } from "../config/constants.ts";
import type { ParticleQuality } from "../utils/types.ts";

export type QualityTier = Exclude<ParticleQuality, "auto">;

export function particleCountFor(quality: ParticleQuality, autoLevel: QualityTier): number {
  const resolved: QualityTier = quality === "auto" ? autoLevel : quality;
  return PARTICLE_COUNTS[resolved];
}

export function nextLower(level: QualityTier): QualityTier {
  if (level === "high") return "medium";
  if (level === "medium") return "low";
  return "low";
}

export function nextHigher(level: QualityTier): QualityTier {
  if (level === "low") return "medium";
  return "high";
}
